export enum TravelXFeatureFlags {
    InAppNotificationsTickets = 'IN_APP_NOTIFICATIONS_TICKETS',
    NovaHousingRequestsClientCleared = 'nova-housing-requests-client-cleared',
    NovaVMSAccountManagerLiveListChanges = 'nova-vms-amlivelist-changes',
    NovaVMSAccountManagerDealsChanges = 'nova-vms-amdeals-changes',
    NovaJobCreationClinicalTrackChanges = 'nova-job-creation-clinical-track-changes',
    NovaRemoveCountFromTasksGrid = 'nova-remove-count-from-tasks-grid',
    ConnectVMSRecruiterSpecificOfferNotes = 'connect-vms-recruiter-specific-offer-notes',
    JobRequirementsRetrieveClinicalTrackSkillsAndCerts = 'job-requirements-retrieve-clinical-track-skills-and-certs',
    NovaHousingRequestsLobColumn = 'nova-housing-requests-lob-column',
    ClearJobQualificationsOnUDOrCTChange = 'clear-job-qualifications-on-ud-or-ct-change',
    AllowJobAndUDWithCTRequirementsCombination = 'allow-job-and-ud-with-ct-requirements-combination',
    AllowJobAndUDWithCTRequirementsComparison = 'add-requirements-comparison-between-job-and-ud-with-ct',
    AllowJobWithCTRequirementsModification = 'allow-job-with-ct-requirements-modification',
    NovaClinicalReviewDetailsShowProgramType = 'nova-clinical-review-details-show-program-type'
}
